document.addEventListener('DOMContentLoaded', event => {

  document.addEventListener('click', function(event) {
    if (document.querySelector('body').classList.contains('production')) {
      if (event.target.href && event.target.href.match(/\.mp3$/)) {
        if (event.target.classList.contains('play')) {
          _gaq.push(['_trackEvent', 'MP3', 'Play', event.target.href])
        } else {
          _gaq.push(['_trackEvent', 'MP3', 'Pause', event.target.href])
        }
      }

      if (event.target.href && event.target.href.match(/\.pdf$/)) {
        _gaq.push(['_trackEvent', 'PDF', 'Download', event.target.href])
      }
    }
  })
})
